export default __webpack_public_path__ + "static/template3-graphique-2a103db056614bfc9c6fc473f525f6ce.svg";